/*eslint-disable*/
import React, { Component } from "react";
import Header from "../../components/Headers/Header";
import { connect } from "react-redux";
import { Card, CardHeader, Table, Row, Col } from "reactstrap";
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import RefreshIcon from "@material-ui/icons/Refresh";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import AdjustIcon from "@material-ui/icons/Adjust";
import NotInterestedIcon from "@material-ui/icons/NotInterested";
import Pagination from "@material-ui/lab/Pagination";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import {
  Grid,
  AppBar,
  Paper,
  Toolbar,
  Tooltip,
  IconButton,
  Button,
  TextField,
  ListItemText,
  List,
  ListItem,
  ListItemAvatar,
  Typography,
  Divider,
} from "@material-ui/core";
import ModalCreateUsers from "../../components/Modal/Modal.CreateUser";
import "react-toastify/dist/ReactToastify.css";
import {
  getAllUsers,
  getUser,
  paginateUsers,
  getClientsFiltered,
} from "../../utils/store/actions/users.actions";
import { show } from "redux-modal";
import { withTranslation } from "react-i18next";

const styles = (theme: Theme) =>
  createStyles({
    paper: {
      backgroundColor: "white",
      maxWidth: "90%",
      margin: "auto",
      marginTop: "5%",
      overflow: "hidden",
    },
    searchBar: {
      backgroundColor: "#F5F6FF",
      borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    },
    searchInput: {
      backgroundColor: "#F5F6FF",
      fontSize: theme.typography.fontSize,
    },
    block: {
      display: "block",
    },
    addUser: {
      marginRight: theme.spacing(1),
    },
    contentWrapper: {
      margin: "40px 16px",
    },
    rowDashboard: {
      height: 100,
      backgroundColor: "transparent",
    },
  });

class UserList extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      totalItems: 0,
      totalPages: 0,
      curentPage: 1,
      load: false,
    };
  }
  componentDidMount() {
    this.props.getAllUsers();
  }

  editUser = (user: any) => {
    this.props.getUser(user.id);
    window.location.href = `/admin/user/?id=${user.id}`;
  };

  handleRefresh = () => {
    this.props.paginateUsers(1);
    this.props.getAllUsers();
  };

  handleChange = (e: any, value: any) => {
    this.setState({ load: !this.state.load });
    this.props.paginateUsers(value, this.state.searchFilter);
  };

  handleChangeDefault = (e: any) => {
    this.props.getClientsFiltered(`name=${e.target.value}`);
    this.setState({ searchFilter: `name=${e.target.value}` });
    const userInput = e.currentTarget.value;

    this.setState({
      activeSuggestion: 0,
      showSuggestions: true,
      userInput: e.currentTarget.value,
    });
  };
  render() {
    const { Users, classes, t } = this.props;
    const disabledButtonCreate =
      this.props.Users &&
      this.props.Users.get_properties &&
      (this.props.Users.get_properties.find(
        (property: { key: string; value: boolean }) =>
          property.key === "IS_V4_AVAILABLE"
      )?.value === "true"
        ? false
        : !(
            this.props.LocalUser &&
            this.props.LocalUser.role &&
            this.props.LocalUser.role.userCanCreate
          ));

    const disabledButtonEdit =
      this.props.Users &&
      this.props.Users.get_properties &&
      (this.props.Users.get_properties.find(
        (property: { key: string; value: boolean }) =>
          property.key === "IS_V4_AVAILABLE"
      )?.value === "true"
        ? false
        : !(
            this.props.LocalUser &&
            this.props.LocalUser.role &&
            this.props.LocalUser.role.userCanEdit
          ));
    return (
      <>
        {/* Page content */}
        <ModalCreateUsers />
        <Row className={classes.rowDashboard}>
          <Col>
            <Card
              style={{
                backgroundColor: "transparent",
                borderBottom: "transparent",
              }}
            >
              <CardHeader
                style={{
                  backgroundColor: "transparent",
                  borderBottom: "transparent",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  paddingRight: "80px",
                }}
              >
                <Row>
                  <Button
                    variant="contained"
                    style={{
                      boxSizing: "border-box",
                      borderRadius: "10px",
                      color: "#ae0064",
                      backgroundColor: "white",
                      width: "200px",
                      height: "50px",
                      textTransform: "none",
                    }}
                    disabled={disabledButtonCreate}
                    className={classes.addUser}
                    onClick={() =>
                      this.props.show("create_user", {
                        name: "create_user",
                        history,
                      })
                    }
                  >
                    <PersonAddIcon style={{ marginRight: "20px" }} />
                    {t("ADD_USER")}
                  </Button>
                </Row>
              </CardHeader>
            </Card>
          </Col>
        </Row>
        <Paper className={classes.paper}>
          <AppBar
            className={classes.searchBar}
            position="static"
            color="default"
            elevation={0}
          >
            <Toolbar>
              <Grid container spacing={2} alignItems="center">
                <Grid item>
                  <SearchIcon className={classes.block} color="inherit" />
                </Grid>
                <Grid item xs>
                  <TextField
                    fullWidth
                    onChange={(e) => this.handleChangeDefault(e)}
                    placeholder={t("SEARCH_BY_NAME")}
                    InputProps={{
                      disableUnderline: true,
                      className: classes.searchInput,
                    }}
                  />
                </Grid>
                <Grid item>
                  <Tooltip title="Reload">
                    <IconButton onClick={this.handleRefresh}>
                      <RefreshIcon className={classes.block} color="inherit" />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
            </Toolbar>
          </AppBar>
          <div className={classes.contentWrapper}>
            {Users && Users.List ? (
              <>
                <List>
                  {Users.List.content.map((user: any) => {
                    return (
                      <div key={user.id}>
                        <ListItem>
                          <ListItemAvatar>
                            <AccountBoxIcon style={{ color: "ae0064" }} />
                          </ListItemAvatar>
                          <ListItemText
                            primary={
                              <div className={classes.truncate}>
                                <strong>
                                  {user ? user.name : "Anonymous"}
                                </strong>{" "}
                                {user.firstName}
                                <strong> {user && user.role}</strong>
                              </div>
                            }
                            secondary={`${user.email}`}
                          />
                          {user.canLogin === true ? (
                            <AdjustIcon
                              style={{
                                color: "green",
                                fontSize: "20px",
                                marginRight: "20px",
                              }}
                            />
                          ) : (
                            <NotInterestedIcon
                              style={{
                                color: "red",
                                fontSize: "20px",
                                marginRight: "20px",
                              }}
                            />
                          )}
                          <Button
                            disabled={disabledButtonEdit}
                            onClick={() => this.editUser(user)}
                            color="primary"
                            style={{ color: "#ae0064", textTransform: "none" }}
                          >
                            {t("EDIT")}
                          </Button>
                        </ListItem>
                        <Divider />
                      </div>
                    );
                  })}
                </List>
                <Pagination
                  count={Users.List.totalPages}
                  page={Users.List.number + 1}
                  onChange={this.handleChange}
                />
              </>
            ) : (
              <>
                <Typography color="textSecondary" align="center">
                  {t("NO_USERS")}
                </Typography>
              </>
            )}
          </div>
        </Paper>
      </>
    );
  }
}

const mapStateToProps = (state: {
  Users: UsersState;
  LocalUser: LocalUserState;
}) => ({
  Users: state.Users,
  LocalUser: state.LocalUser,
});
const mapDispatchToProps = {
  getAllUsers,
  getUser,
  paginateUsers,
  show,
  getClientsFiltered,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(UserList)));
